// extracted by mini-css-extract-plugin
module.exports = {"notificationBody":"FirebaseConfig_notificationBody__19Yrq"};